import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import API_URL from "../../config";

const EditRecruiter = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [recruiter, setRecruiter] = useState({
        organization_name: "",
        organization_type: "",
        city: "",
        state: "",
        subscription_plan: "",
        recruiter_name: "",
        company_name: "",
        company_logo: "",
        phone: "",
        email: "",
        website: "",
        address: "",
        about: ""
    });

    useEffect(() => {
        fetchRecruiter();
    }, []);

    const fetchRecruiter = async () => {

        try {

            const response = await axios.get(
                `${API_URL}/admin/recruiters/${id}`
            );

            setRecruiter(response.data.data);

        } catch (err) {

            console.error(err);
            alert("Unable to load recruiter.");

        } finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        setRecruiter({
            ...recruiter,
            [e.target.name]: e.target.value
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await axios.put(
                `${API_URL}/admin/recruiters/${id}`,
                recruiter
            );

            alert("Recruiter updated successfully.");

            navigate("/admin/recruiters");

        } catch (err) {

            console.error(err);
            alert("Update failed.");

        }

    };

    if (loading) {

        return (
            <Loader
                fullScreen
                text="Loading Recruiter..."
            />
        );

    }

    return (

        <div className="space-y-6">

            <PageHeader
                title="Edit Recruiter"
                subtitle="Update recruiter details"
                showButton={false}
                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Recruiters",
                        link: "/admin/recruiters"
                    },
                    {
                        label: "Edit Recruiter"
                    }
                ]}
            />

            <div className="bg-white rounded-3xl shadow-lg p-8">

                <form
                    onSubmit={handleSubmit}
                    className="grid grid-cols-1 md:grid-cols-2 gap-6"
                >

                    <div>
                        <label className="block mb-2 font-medium">
                            Organization Name
                        </label>

                        <input
                            type="text"
                            name="organization_name"
                            value={recruiter.organization_name}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Organization Type
                        </label>

                        <input
                            type="text"
                            name="organization_type"
                            value={recruiter.organization_type}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Recruiter Name
                        </label>

                        <input
                            type="text"
                            name="recruiter_name"
                            value={recruiter.recruiter_name}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Company Name
                        </label>

                        <input
                            type="text"
                            name="company_name"
                            value={recruiter.company_name}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Email
                        </label>

                        <input
                            type="email"
                            name="email"
                            value={recruiter.email}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Phone
                        </label>

                        <input
                            type="text"
                            name="phone"
                            value={recruiter.phone}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Website
                        </label>

                        <input
                            type="text"
                            name="website"
                            value={recruiter.website}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            Company Logo
                        </label>

                        <input
                            type="text"
                            name="company_logo"
                            value={recruiter.company_logo}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            City
                        </label>

                        <input
                            type="text"
                            name="city"
                            value={recruiter.city}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">
                            State
                        </label>

                        <input
                            type="text"
                            name="state"
                            value={recruiter.state}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-2 font-medium">
                            Address
                        </label>

                        <textarea
                            rows="3"
                            name="address"
                            value={recruiter.address}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-2 font-medium">
                            About
                        </label>

                        <textarea
                            rows="4"
                            name="about"
                            value={recruiter.about}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />
                    </div>

                    <div className="flex justify-end gap-4 md:col-span-2">

                        <button
                            type="button"
                            onClick={() => navigate("/admin/recruiters")}
                            className="px-6 py-3 rounded-xl bg-gray-200 hover:bg-gray-300"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="px-6 py-3 rounded-xl bg-teal-600 text-white hover:bg-teal-700"
                        >
                            Update Recruiter
                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

};

export default EditRecruiter;